import { render, staticRenderFns } from "./InvestmentAssetItem.vue?vue&type=template&id=34579b32&"
import script from "./InvestmentAssetItem.vue?vue&type=script&lang=js&"
export * from "./InvestmentAssetItem.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentAssetItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports